var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsApp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #00d95f;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.86,
    width: 25,
    height: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.17.86H6.83C3.33.86.5,3.69.5,7.19v12.34c0,3.49,2.83,6.33,6.33,6.33h12.34c3.49,0,6.33-2.83,6.33-6.33V7.19c0-3.49-2.83-6.33-6.33-6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m4.87,22.02l1.24-4.62c-.7-1.27-1.07-2.69-1.07-4.12,0-4.7,3.83-8.53,8.53-8.53s8.53,3.83,8.53,8.53-3.83,8.53-8.53,8.53c-1.41,0-2.81-.36-4.05-1.03l-4.64,1.24h0Zm4.88-2.98l.29.18c1.08.64,2.29.98,3.54.98,3.82,0,6.92-3.1,6.92-6.92s-3.1-6.92-6.92-6.92-6.92,3.1-6.92,6.92c0,1.26.35,2.5,1.01,3.59l.18.29-.69,2.58,2.59-.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m16.75,14.46c-.35-.21-.81-.44-1.23-.28-.32.13-.52.63-.73.88-.11.13-.23.15-.39.08-1.19-.48-2.1-1.27-2.76-2.37-.11-.17-.09-.31.04-.46.2-.23.45-.5.5-.82.05-.32-.09-.68-.23-.97-.17-.36-.35-.87-.71-1.08-.33-.18-.77-.08-1.06.16-.51.42-.75,1.06-.74,1.7,0,.18.03.37.07.54.1.43.3.82.52,1.19.17.28.35.56.54.83.63.87,1.43,1.62,2.35,2.18.46.28.95.53,1.47.7.58.19,1.08.38,1.7.27.65-.12,1.28-.53,1.54-1.15.08-.18.12-.39.08-.58-.09-.4-.63-.64-.96-.84h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whatsApp.4581c15d4d0018d4fb3a155e913cf100.svg";
export { ForwardRef as ReactComponent };